export const lightTheme = {
    body: '#F5F5F5',
    text: '#000',
    toggleBorder: '#FFF',
    background: 'linear-gradient(35deg, #60aed3, #5c3de4)',
  };
  
  export const darkTheme = {
    body: '#1f1f1f',
    text: '#FFF',
    toggleBorder: '#6B8096',
    background: '#999',
  };